<template>
  <div class="row-cell row_cell_bottom">
    <div
      class="row-cell-title">
      {{title}}
      <div
        class="row-cell-right"
        @click="goMoreList(typeId)">
        <span>更多</span>
        <img :src="require('../assets/images/mine/more.png')"/>
      </div>
    </div>
    <div
      class="row-cell-content" >
      <ul class="row-cell-content-view">
        <li
          v-for="(item) in list"
          :key="`${item.id}-${changeIndex}`"
          class="row-cell-content-view-cell "
          @click="goPlayVideo(item.id)">
          <transition name="van-fade">
            <base-image
              class="row-cell-recommand"
              :fit="`cover`"
              :ratio="360/203"
              :encrypt="true"
              :url="item.coverbase64.url"
              :type="item.coverbase64.type">
            </base-image>
          </transition>
          <p class="title">{{ item.title }}</p>
        </li>
      </ul>
    </div>
    <div
      v-if="list.length && showChangeBtn"
      class="row-cell-change">
      <div @click="changeIndex++">
        <img
          class="row-cell-change-icon"
          :src="require('../assets/images/home/home_change@3x.png')"/>
        换一批
      </div>
    </div>
  </div>
</template>

<script>
import baseImage from '@/components/baseImage'

const VIDEO_QUANTITY = 4

export default {
  name: 'homeVideoBlock',
  components: {
    baseImage
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    typeId: {
      type: Number,
      default: 0
    },
    propsList: {
      type: Array,
      default: function () {
        return []
      }
    },
    showChangeBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      changeIndex: 0,
      list: []
    }
  },
  watch: {
    /**
     * 在滿足有12部影片時： 依序4部呈現至畫面共會有3次是完全不同的影片(12/4 = 3)，之後亂數排序後再重複上述動作
     * 若該次呈現不滿足4部影片時，則將剩餘影片再透過亂數排序後與原先要呈現的影片進行合併並挑選前4部來呈現
     * 若該次呈現的影片數為0，則直接進行亂數排序
     */
    changeIndex (newValue, oldValue) {
      if (this.propsList.length <= VIDEO_QUANTITY) return
      if (newValue < 3) {
        const newList = this.propsList.slice(newValue * VIDEO_QUANTITY, (newValue + 1) * VIDEO_QUANTITY)
        if (newList.length === VIDEO_QUANTITY) {
          this.list = newList
        } else if (newList.length !== 0) {
          const randomList = this.handleShuffle(this.propsList, newList, false)
          this.list = newList.concat(randomList).slice(0, VIDEO_QUANTITY)
        } else {
          this.handleShuffle(this.propsList)
          this.changeIndex = 0
        }
      } else {
        this.handleShuffle(this.propsList)
        this.changeIndex = 0
      }
    },
    propsList: {
      handler () {
        this.list = this.showChangeBtn ? this.propsList.slice(0, VIDEO_QUANTITY) : this.propsList
      },
      immediate: true
    }
  },
  methods: {
    goMoreList (typeId) {
      this.$router.push({
        path: '/list',
        query: {
          typeId
        }
      })
    },
    goPlayVideo (id) {
      this.$router.push({
        path: '/playVideo',
        query: {
          id
        }
      })
    },
    /**
     * use : Fisher–Yates shuffle Algorithm
     */
    handleShuffle (array, excludeArray = [], isUpdatePropsList = true) {
      if (excludeArray.length !== 0) {
        const excludeIdArray = excludeArray.map(item => item.id)
        array = array.filter(item => excludeIdArray.indexOf(item.id) === -1)
      }

      for (let i = array.length - 1, j, tmp; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1))
        tmp = array[i]
        array[i] = array[j]
        array[j] = tmp
      }

      return isUpdatePropsList ? this.$emit('update:propsList', array) : array
    }
  }

}
</script>

<style scoped>
.row-cell {
  position: relative;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 15px;
}

.row_cell_bottom {
  border-bottom: 10px solid #222;
}

.row-cell-title {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 1.5rem;
  padding-left: 8px;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.5rem;
  color: #fff;
  text-align: left;
}

.row-cell-title::after {
  position: absolute;
  top: 15%;
  bottom: 0;
  left: 0;
  width: 3px;
  height: 70%;
  content: "";
  background-color: #f75b2b;
}

.row-cell-right {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 1.5rem;
  font-size: 1.3rem;
  line-height: 1.5rem;
  color: #f75b2b;
  text-align: right;
}

.row-cell-right img {
  width: 7px;
  height: 14px;
  margin-top: -3px;
  margin-left: 7px;
  vertical-align: middle;
}

.row-cell-content {
  position: relative;
  width: 100%;
  margin: 10px 0 0 0;
}

.row-cell-content-view {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 0 0;
  margin: 0 0;
  list-style: none;
}

.row-cell-content-view-cell {
  position: relative;
  width: 49%;
  border-radius: 5px;
}

.row-cell-content-view-cell .title {
  box-sizing: border-box;
  width: 100%;
  padding: 0 5%;
  margin: 0 0 10px 0;
  overflow: hidden;
  font-size: 1.3rem;
  color: #fff;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-cell-recommand {
  width: 100%;
  height: 0;
  padding-bottom: 56.3889%;
  overflow: hidden;
}

.row-cell-change {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0;
  font-size: 1.3rem;
  font-weight: 500;
  color: #f75b2b;
  text-align: center;
}

.row-cell-change-icon {
  width: 1.125rem;
  height: 1.125rem;
  margin-top: -0.1875rem;
  margin-left: 0.4375rem;
  vertical-align: middle;
}

</style>



// WEBPACK FOOTER //
// src/components/homeVideoBlock.vue